export function mapFields(options) {
  const object = {};
  for (let x = 0; x < options.fields.length; x++) {
    const field = [options.fields[x]];
    object[field] = {
      get() {
        return this.$store.state[options.base][field];
      },
      set(value) {
        this.$store.commit(options.mutation, { [field]: value });
      },
    };
  }
  return object;
}

function strToISODateString(str) {
  return new Date(str)
    .toISOString()
    .replace(/:/g, "-")
    .replace(".000", "")
    .replace("Z", "");
}

/**
 *
 * @param {Objecy} filters
 * @param {String} logicalOperator
 * Builds ASP.NET MVC Kendo style filter string
 * &filter=(userName~contains~%27mateus%27~and~firstName~contains~%27mateus%27~or~lastName~contains~%27mateus%27~or~role~contains~%27mateus%27~or~supervisor~contains~%27mateus%27~or~fullAddress~contains~%27mateus%27)
 */

export function ChiStringifyFilter(filters, logicalOperator = "and") {
  // [ { field: "birthCountry", operator: "eq", value: "Brazil" }, ];
  if (!filters || !filters.length) {
    return "";
  }

  const string = filters.reduce((strFields, filter) => {
    if (strFields && strFields.length) {
      strFields += `~${logicalOperator}~`;
    }
    strFields += Object.keys(filter).reduce((strFilter, key) => {
      //   { field: "name", operator: "contains", value: "Coffee" },
      let val = filter[key];

      if (key === "value") {
        switch (typeof val) {
          case "string":
            if (!isNaN(Date.parse(val))) {
              const format = strToISODateString(val);
              val = `datetime'${format}'`;
            } else {
              val = `'${val}'`;
            }
            break;
          case "object":
            if (val instanceof Date && !isNaN(val.getTime())) {
              val = `datetime'${strToISODateString(val)}'`;
            } else {
              val = "INVALID VALUE";
            }
            break;
          default:
            val = `${val}`;
            break;
        }
      }

      // field~operator~'value'
      return strFilter + ((strFilter ? "~" : "") + val);
    }, "");

    // field~operator~value~logicalOperator~ield~operator~value
    return strFields;
  }, "");
  // console.log(string);
  // return `&filter=(birthDate~lte~datetime%272002-10-21T18-40-00%27~and~birthDate~gte~datetime%271990-10-21T17-40-00%27~and~drivingExperience~eq~2)`;
  return `&filter=(${string})`;
}

export function serialize(obj) {
  let queryString = "";
  for (let key in obj) {
    queryString += `&${key}=${obj[key]}`;
  }
  return queryString;
}

export function USStates() {
  return {
    AL: "Alabama",
    AK: "Alaska",
    AS: "American Samoa",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District Of Columbia",
    FM: "Federated States Of Micronesia",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MH: "Marshall Islands",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    MP: "Northern Mariana Islands",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PW: "Palau",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VI: "Virgin Islands",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  };
}

export function getApplicationLevel(state) {
  if (state.match) {
    return 5; //matched
  }
  if (state.matchRequest) {
    return 4; //matchrequested
  }

  if (state.requestInterview.length) {
    return 3; //interview requested
  }
  if (state.favoriteAuPairs.length && state.requestInterview.length === 0) {
    return 2; //has an au pair on favorites
  }
  return 1; //has no favorites
}
